import { Component } from '@angular/core';

@Component({
  selector: 'app-report-beta-badge',
  templateUrl: './report-beta-badge.component.html',
  styleUrls: ['./report-beta-badge.component.scss']
})
export class ReportBetaBadgeComponent {

}
